import { render, staticRenderFns } from "./ledgerReport.vue?vue&type=template&id=f66ee132&scoped=true"
import script from "./ledgerReport.vue?vue&type=script&lang=js"
export * from "./ledgerReport.vue?vue&type=script&lang=js"
import style0 from "./ledgerReport.vue?vue&type=style&index=0&id=f66ee132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66ee132",
  null
  
)

export default component.exports